import { useContext } from "react";
import { AuthContext } from "./util/api";

export default function Footer() {
  const { info } = useContext(AuthContext);

  return (
    <>
    { info !=  null  &&

      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div>
            <div style={{ fontWeight: 900, fontSize: 18 }}>{info.org_name != null ? info.org_name : " "}</div>
            <div style={{ marginTop: 6, opacity: 0.88 }}>{info.org_location != null ? info.org_location : " "}</div>
          </div>

          <div style={styles.socials}>

            <a style={styles.socialLink} href={info.facebook != null ? info.facebook : " "} aria-label="Facebook">Facebook</a>

            <a style={styles.socialLink} href={info.youtube != null ? info.youtube : " "} aria-label="Youtube">Youtube</a>


          </div>
        </div>

        <div style={styles.copyright}>© {new Date().getFullYear()} {info.org_name != null ? info.org_name : " "}</div>
      </footer>

    }




    </>
  );

}

const styles = {
  container: {
    fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    color: "#08324A",
    lineHeight: 1.5,
    overflowX: "hidden",
  },

  /* FOOTER */
  footer: {
    background: "#0A3D62",
    color: "#fff",
    padding: "34px 28px 40px",
    marginTop: 40,
    borderRadius: 12,
    marginLeft: 12,
    marginRight: 12,
  },
  footerInner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    maxWidth: 1180,
    margin: "0 auto",
  },
  socials: {
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  socialLink: {
    padding: "8px 12px",
    borderRadius: 8,
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    textDecoration: "none",
    fontWeight: 700,
  },
  copyright: {
    marginTop: 18,
    maxWidth: 1180,
    marginLeft: "auto",
    marginRight: "auto",
    opacity: 0.9,
    fontSize: 13,
  },
};